import { TextInput, TextInputProps, useTranslate } from 'react-admin';
import { Box, InputLabel } from '@mui/material';

export const GrayTextInputWithUpperLabel = (props: TextInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();
  return (
    <Box display="flex" flexDirection="column" sx={{ width: '100%' }}>
      <InputLabel className="input-label" required={props.isRequired}>
        {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
      </InputLabel>
      <TextInput
        {...props}
        label={false}
        fullWidth={props.fullWidth ?? true}
        inputProps={{
          ...props.inputProps,
          style: {
            backgroundColor: '#f1f1f1',
            borderRadius: '5px',
            ...props.inputProps?.style,
          },
        }}
        sx={{
          width: '100%',
          ...props.sx,
          '& fieldset': {
            border: 'none',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f1f1 !important',
          },
        }}/>
    </Box>
  );

};
